<template>
  <div class="property_wrapper">
    <h3 v-if="heading" class="property_wrapper--heading text-uppercase">{{ heading }}</h3>

    <div v-if="upgradeRequired">
      <p class="property_wrapper--upgrade">
        Upgrade required to see this data.
        <a @click="openBillingPortal">Upgrade your account today</a>
      </p>
    </div>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "PropertyModalWrapper",
  props: {
    heading: {
      type: String,
    },
    upgradeRequired: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.property_wrapper {
  margin-top: 4rem;

  &--heading {
    margin-bottom: 1rem;
    font-size: 1.125rem;
    text-align: center;
  }

  &--upgrade {
    margin: 2rem 0;
    text-align: center;
    font-style: italic;
  }
}
</style>
